import Image from 'next/image'
import { Event, stages } from './utils'

interface Props {
  stage: number
  data: Event
}

function ScheduleCard({ stage, data }: Props): JSX.Element {
  return (
    <section
      className="py-4 px-5"
      style={{ background: stages[stage].gradient }}
    >
      <div className="flex items-center justify-between | mb-4">
        <p
          className="text-blue-web-90 font-medium | rounded | w-fit | py-0.5 px-1.5"
          style={{
            background: 'linear-gradient(90deg, #FFCA33 0%, #FF80B8 100%)'
          }}
        >
          {data.type}
        </p>
        <p>{data.time}</p>
      </div>

      <div>
        <p className="text-2xl font-heading font-bold text-center | mb-3">
          {data.title}
        </p>
        <div className="flex items-center justify-center gap-8 flex-wrap">
          {data.speakers.map(speaker => (
            <div key={speaker.name} className="max-w-[140px]">
              <Image
                className="rounded-full | w-28 h-w-28 | mb-2 mx-auto"
                src={speaker.avatar ?? ''}
                alt={speaker.name}
                width="226"
                height="226"
              />
              <p className="text-caption | border border-white rounded | w-fit | px-1 mb-2">
                {speaker.type}
              </p>

              <p className="font-bold">{speaker.name}</p>
              <p className="text-caption font-heading font-bold">
                {speaker.designation}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default ScheduleCard
